<template>
    <div>
        <svg :width="iconSize" :height="iconSize" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M10.5 0.34375C4.89086 0.34375 0.34375 4.89086 0.34375 10.5C0.34375 16.1091 4.89086 20.6562 10.5 20.6562C16.1091 20.6562 20.6562 16.1091 20.6562 10.5C20.6562 4.89086 16.1091 0.34375 10.5 0.34375ZM6.903 2.69297C3.9533 4.05427 1.90625 7.03808 1.90625 10.5C1.90625 15.2462 5.7538 19.0938 10.5 19.0938C14.9938 19.0938 18.682 15.6445 19.0616 11.249L18.5815 10.7689C18.4033 10.5908 18.2551 10.3851 18.1424 10.1598L17.0174 7.90969C16.8858 7.64664 16.5353 7.58975 16.3273 7.79771C16.106 8.019 15.7821 8.10293 15.4812 8.01695L14.1553 7.63812C13.6517 7.49424 13.1291 7.79609 13.0021 8.30416C12.9072 8.68397 13.0612 9.08246 13.387 9.29962L13.9981 9.70708C14.6135 10.1173 14.6997 10.9879 14.1767 11.5108L13.9683 11.7193C13.7485 11.939 13.625 12.2371 13.625 12.5479V12.9758C13.625 13.4006 13.5096 13.8174 13.291 14.1817L11.9216 16.464C11.5244 17.1261 10.8088 17.5312 10.0367 17.5312C9.42962 17.5312 8.93753 17.0392 8.93753 16.4321V15.2118C8.93753 14.2534 8.35405 13.3916 7.46422 13.0357L6.78283 12.7631C5.76018 12.3541 5.16034 11.2881 5.34141 10.2017L5.34874 10.1577C5.39708 9.86766 5.49957 9.5893 5.65086 9.33716L5.74399 9.18193C6.2536 8.33259 7.24212 7.89529 8.21339 8.08955L9.44031 8.33493C10.0389 8.45466 10.6292 8.09475 10.7969 7.50775L11.0141 6.74765C11.169 6.20542 10.9158 5.62975 10.4114 5.37755L9.71878 5.03125L9.624 5.12603C9.18446 5.56557 8.58832 5.8125 7.96671 5.8125H7.77825C7.52007 5.8125 7.27185 5.91567 7.08929 6.09823C6.79401 6.39352 6.34185 6.46778 5.96834 6.28103C5.46287 6.0283 5.27954 5.39873 5.5703 4.91413L6.903 2.69297Z" 
                :fill="color"
            />
        </svg>
    </div>
</template>

<script>
export default {
    name: 'IconSvgAGDSubmitCEOnline',
    props: {
        color: {
            type: String,
            default: '#000000',
        },
        size: {
            type: Number,
            default: null
        }
    },
    computed: {
        iconSize() {
            return this.size ? `${this.size}px` : '44px'
        }
    }
};
</script>

<style scoped></style>